import { NAME } from "./constants";

export const getLoadingStatus = state => {
  return state.pages[NAME].isLoading;
};

export const getUsers = state => {
  return state.pages[NAME].users;
};
